import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePageComponent } from './home-page/home-page.component';
import { MissionPageComponent } from './mission-page/mission-page.component';
import { ServicesPageComponent } from './services-page/services-page.component';
import { ContactsPageComponent } from './contacts-page/contacts-page.component';
import { MembershipsComponent } from './memberships/memberships.component';
import { CertificationsComponent } from './certifications/certifications.component';
import { CareersComponent } from './careers/careers.component';
import { ProjectsComponent } from './projects/projects.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { PartnersPageComponent } from './partners-page/partners-page.component';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    MissionPageComponent,
    ServicesPageComponent,
    ContactsPageComponent,
    MembershipsComponent,
    CertificationsComponent,
    CareersComponent,
    ProjectsComponent,
    AboutUsComponent,
    PartnersPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
